import styled from 'styled-components'

export const ProcessStepsContainer = styled.div`
	max-width: 1440px;
	width: 100%;
	padding: 0 10px;
	box-sizing: border-box;
	margin: 50px auto;
	display: flex;
	flex-direction: column;

	@media(max-width: 1024px){
	margin: 43px auto 50px auto;
	}
`

export const ProcessStepsCardsList = styled.div`
	display: flex;
	margin: 0 auto;
	gap: 5px;
	justify-content: space-evenly;
	max-width: 1400px;
	width: 100%;
	

	@media(max-width: 1024px) {
	flex-wrap: wrap;
	 }
`

export const CardColumn = styled.div`
	max-width: 120px;
`

export const CardColumns = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 45px;
	margin-top: 22px;
`

export const CardText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 13px;
	line-height: 16px;
	letter-spacing: -0.03em;
	color: #2c2c2c;
	max-width: 210px;
	margin-top: 15px;

	@media (max-width: 1024px) {
		max-width: 100%;
		margin-top: 20px;
	}
`

export const Label = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 13px;
	color: #01924f;
	margin-bottom: 3px;
`
export const Text = styled(CardText)`
	@media (max-width: 1024px) {
		margin-top: 3px;
	}
`
export const List = styled.div`
	margin-top: 12px;

	@media (max-width: 1024px) {
		margin-top: 0px;
	}
`
export const ListItem = styled(CardText)`
	margin: 0;
`
